import { GetBy } from '../_app/cuchillo/core/Element';
import { ControllerPage } from '../_app/cuchillo/pages/ControllerPage';
import Default from './Default';

export default class Home extends Default {
  hasVideo = false;
  video;

  constructor() {
    super();
  }

  beforeShow() {
    super.beforeShow();

    const video = GetBy.selector('.block-landing .__img video')[0];

    if (video) {
      document.documentElement.classList.add('--video');
      this.hasVideo = true;
    }
  }

  afterHide() {
    super.afterHide();

    if (this.hasVideo) document.documentElement.classList.remove('--video');
  }
}

ControllerPage._addPage('home', Home);
